import { Box } from '@mui/material';
import { SidePanelHeader } from './SidePanelHeader';

export function SidePanel(props) {
  const { close, children, title, subtitle } = props;

  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'flex' },
        flexDirection: 'column',
        position: 'relative',
        p: 2,
        minWidth: 400,
        overflow: 'hidden',

        '& .focused': {
          backgroundColor: '#e7ede4',
        },
      }}
    >
      <SidePanelHeader title={title} subtitle={subtitle} close={close} />
      <Box sx={{ flex: 1, overflow: 'auto' }}>{children}</Box>
    </Box>
  );
}
